export enum ResponseMessageType {
    SHOW="SHOW",
	INFO="INFO",
	SUCCESS="SUCCESS",
	WARNING="WARNING",
	ERROR="ERROR",
}
